import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SupergridSettings {
	lifetimeStats: boolean;
	toggleLifetimeStats: () => void;
	setLifetimeStats: (lifetimeStats: boolean) => void;
	resetStore: () => void;
}

const useSupergridSettings = create<SupergridSettings>()(persist(
	(set) => ({
		lifetimeStats:       false,
		toggleLifetimeStats: () => set((state) => ({ lifetimeStats: !state.lifetimeStats })),
		setLifetimeStats:    (lifetimeStats: boolean) => set({ lifetimeStats }),
		resetStore:          () => set({ lifetimeStats: false }),
	}),
	{
		name:       'spotifySupergridSettings',
		partialize: ({ lifetimeStats }) => ({ lifetimeStats }),
	},
));

export default useSupergridSettings;
